"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SinglyLinkedList = function () {
  function SinglyLinkedList() {
    this.head = null;
    this.tail = null;
  }

  SinglyLinkedList.prototype.add = function (node) {
    if (!this.head) {
      this.head = this.tail = node;
    } else if (this.head !== node && this.tail) {
      this.tail.next = node;
      this.tail = node;
    }
  };

  return SinglyLinkedList;
}();

exports.SinglyLinkedList = SinglyLinkedList;